import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Or37bzl6q9twftg as Or,
  And1a3dbpwh0hxmu as And,
  Conditionlbcfpsbet24r as Condition,
  Notasovrzfq2v0i as Not,
  NotInside2gyw9f0e86unn as NotInside,
  Always2gnog82xa5sk4 as Always,
  Inside34e21e5w7gmr5 as Inside,
  Neverceenm6qv9xac as Never,
  Equal31pr842ymh8s6 as Equal,
  NotEqual3by2u1rdr6xhj as NotEqual,
  OnField2kq8b4gk936v8 as OnField,
  OnKey39cswdy1celtm as OnKey,
  IfNotNullvieyp8szlv3m as IfNotNull,
  ListAllElements2qkljsceytb8 as ListAllElements,
  ListAnyElements3oaaxxe9tp3p5 as ListAnyElements,
  SetAllElementso97viygbubrg as SetAllElements,
  SetAnyElements2se8zlywewplk as SetAnyElements,
  LessThanOrEqual3o5tj78evuy34 as LessThanOrEqual,
  LessThan328qpp4kkt6qa as LessThan,
  GreaterThanOrEqual3ghjzsakr35no as GreaterThanOrEqual,
  GreaterThan3vt01ywx1j4sj as GreaterThan,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function impliesCondition(narrow, broad) {
  if (narrow.equals(broad))
    return true;
  if (matchesEverything(broad))
    return true;
  if (matchesNothing(narrow))
    return true;
  if (broad instanceof And()) {
    var tmp0 = broad.conditions_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(tmp0, Collection())) {
        tmp = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (!impliesCondition(narrow, element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  } else {
    if (broad instanceof Or()) {
      var tmp0_0 = broad.conditions_1;
      var tmp$ret$2;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0_0, Collection())) {
          tmp_0 = tmp0_0.isEmpty_y1axqb_k$();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$2 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          if (impliesCondition(narrow, element_0)) {
            tmp$ret$2 = true;
            break $l$block_2;
          }
        }
        tmp$ret$2 = false;
      }
      return tmp$ret$2;
    } else {
      if (narrow instanceof And()) {
        var tmp0_1 = narrow.conditions_1;
        var tmp$ret$4;
        $l$block_4: {
          // Inline function 'kotlin.collections.any' call
          var tmp_1;
          if (isInterface(tmp0_1, Collection())) {
            tmp_1 = tmp0_1.isEmpty_y1axqb_k$();
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp$ret$4 = false;
            break $l$block_4;
          }
          var _iterator__ex2g4s_1 = tmp0_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
            var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
            if (impliesCondition(element_1, broad)) {
              tmp$ret$4 = true;
              break $l$block_4;
            }
          }
          tmp$ret$4 = false;
        }
        return tmp$ret$4;
      } else {
        if (narrow instanceof Or()) {
          var tmp0_2 = narrow.conditions_1;
          var tmp$ret$6;
          $l$block_6: {
            // Inline function 'kotlin.collections.all' call
            var tmp_2;
            if (isInterface(tmp0_2, Collection())) {
              tmp_2 = tmp0_2.isEmpty_y1axqb_k$();
            } else {
              tmp_2 = false;
            }
            if (tmp_2) {
              tmp$ret$6 = true;
              break $l$block_6;
            }
            var _iterator__ex2g4s_2 = tmp0_2.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
              var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
              if (!impliesCondition(element_2, broad)) {
                tmp$ret$6 = false;
                break $l$block_6;
              }
            }
            tmp$ret$6 = true;
          }
          return tmp$ret$6;
        }
      }
    }
  }
  var tmp0_safe_receiver = exactValues(narrow);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp$ret$10;
    $l$block_8: {
      // Inline function 'kotlin.collections.all' call
      var tmp_3;
      if (isInterface(tmp0_safe_receiver, Collection())) {
        tmp_3 = tmp0_safe_receiver.isEmpty_y1axqb_k$();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$10 = true;
        break $l$block_8;
      }
      var _iterator__ex2g4s_3 = tmp0_safe_receiver.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
        var element_3 = _iterator__ex2g4s_3.next_20eer_k$();
        if (!(broad instanceof Condition() ? broad : THROW_CCE()).invoke_wbynzd_k$(element_3)) {
          tmp$ret$10 = false;
          break $l$block_8;
        }
      }
      tmp$ret$10 = true;
    }
    return tmp$ret$10;
  }
  var tmp1_safe_receiver = negated(narrow);
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = negated(broad);
    var tmp_4;
    if (tmp0_safe_receiver_0 == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.let' call
      return impliesCondition(tmp0_safe_receiver_0, tmp1_safe_receiver);
    }
  }
  var tmp2_safe_receiver = unwrapMatching(narrow, broad);
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var a = tmp2_safe_receiver.component1_7eebsc_k$();
    var b = tmp2_safe_receiver.component2_7eebsb_k$();
    return impliesCondition(a, b);
  }
  var tmp3_elvis_lhs = asBound(narrow);
  var tmp_5;
  if (tmp3_elvis_lhs == null) {
    return false;
  } else {
    tmp_5 = tmp3_elvis_lhs;
  }
  var n = tmp_5;
  var tmp4_elvis_lhs = asBound(broad);
  var tmp_6;
  if (tmp4_elvis_lhs == null) {
    return false;
  } else {
    tmp_6 = tmp4_elvis_lhs;
  }
  var b_0 = tmp_6;
  if (!(n.lower_1 === b_0.lower_1))
    return false;
  var tmp5_elvis_lhs = compareBoundValues(n.value_1, b_0.value_1);
  var tmp_7;
  if (tmp5_elvis_lhs == null) {
    return false;
  } else {
    tmp_7 = tmp5_elvis_lhs;
  }
  var c = tmp_7;
  var tmp_8;
  if (n.lower_1) {
    tmp_8 = b_0.inclusive_1 ? c >= 0 : c > 0 || (c === 0 && !n.inclusive_1);
  } else {
    tmp_8 = b_0.inclusive_1 ? c <= 0 : c < 0 || (c === 0 && !n.inclusive_1);
  }
  return tmp_8;
}
function matchesEverything(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Always()) {
    tmp = true;
  } else {
    if (_this__u8e3s4 instanceof NotInside()) {
      tmp = _this__u8e3s4.values_1.isEmpty_y1axqb_k$();
    } else {
      if (_this__u8e3s4 instanceof And()) {
        var tmp0 = _this__u8e3s4.conditions_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp_0;
          if (isInterface(tmp0, Collection())) {
            tmp_0 = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (!matchesEverything(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof Not()) {
          tmp = matchesNothing(_this__u8e3s4.condition_1);
        } else {
          tmp = false;
        }
      }
    }
  }
  return tmp;
}
function matchesNothing(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Never()) {
    tmp = true;
  } else {
    if (_this__u8e3s4 instanceof Inside()) {
      tmp = _this__u8e3s4.values_1.isEmpty_y1axqb_k$();
    } else {
      if (_this__u8e3s4 instanceof Or()) {
        var tmp0 = _this__u8e3s4.conditions_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp_0;
          if (isInterface(tmp0, Collection())) {
            tmp_0 = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp_0 = false;
          }
          if (tmp_0) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (!matchesNothing(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        tmp = tmp$ret$0;
      } else {
        if (_this__u8e3s4 instanceof Not()) {
          tmp = matchesEverything(_this__u8e3s4.condition_1);
        } else {
          tmp = false;
        }
      }
    }
  }
  return tmp;
}
function exactValues(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Equal()) {
    tmp = setOf(_this__u8e3s4.value_1);
  } else {
    if (_this__u8e3s4 instanceof Inside()) {
      tmp = _this__u8e3s4.values_1;
    } else {
      tmp = null;
    }
  }
  return tmp;
}
function negated(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Not()) {
    var tmp_0 = _this__u8e3s4.condition_1;
    tmp = tmp_0 instanceof Condition() ? tmp_0 : THROW_CCE();
  } else {
    if (_this__u8e3s4 instanceof NotEqual()) {
      tmp = Equal().new_com_lightningkite_services_database_Condition_Equal_nldxtl_k$(_this__u8e3s4.value_1);
    } else {
      if (_this__u8e3s4 instanceof NotInside()) {
        tmp = Inside().new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(_this__u8e3s4.values_1);
      } else {
        tmp = null;
      }
    }
  }
  return tmp;
}
function unwrapMatching(narrow, broad) {
  var tmp;
  var tmp_0;
  if (narrow instanceof OnField()) {
    tmp_0 = broad instanceof OnField();
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var tmp_1;
    if (equals(narrow.key_1, broad.key_1)) {
      var tmp_2 = narrow.condition_1;
      var tmp_3 = tmp_2 instanceof Condition() ? tmp_2 : THROW_CCE();
      var tmp_4 = broad.condition_1;
      tmp_1 = to(tmp_3, tmp_4 instanceof Condition() ? tmp_4 : THROW_CCE());
    } else {
      tmp_1 = null;
    }
    tmp = tmp_1;
  } else {
    var tmp_5;
    if (narrow instanceof OnKey()) {
      tmp_5 = broad instanceof OnKey();
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      var tmp_6;
      if (narrow.key_1 === broad.key_1) {
        var tmp_7 = narrow.condition_1;
        var tmp_8 = tmp_7 instanceof Condition() ? tmp_7 : THROW_CCE();
        var tmp_9 = broad.condition_1;
        tmp_6 = to(tmp_8, tmp_9 instanceof Condition() ? tmp_9 : THROW_CCE());
      } else {
        tmp_6 = null;
      }
      tmp = tmp_6;
    } else {
      var tmp_10;
      if (narrow instanceof IfNotNull()) {
        tmp_10 = broad instanceof IfNotNull();
      } else {
        tmp_10 = false;
      }
      if (tmp_10) {
        var tmp_11 = narrow.condition_1;
        var tmp_12 = tmp_11 instanceof Condition() ? tmp_11 : THROW_CCE();
        var tmp_13 = broad.condition_1;
        tmp = to(tmp_12, tmp_13 instanceof Condition() ? tmp_13 : THROW_CCE());
      } else {
        var tmp_14;
        if (narrow instanceof ListAllElements()) {
          tmp_14 = broad instanceof ListAllElements();
        } else {
          tmp_14 = false;
        }
        if (tmp_14) {
          var tmp_15 = narrow.condition_1;
          var tmp_16 = tmp_15 instanceof Condition() ? tmp_15 : THROW_CCE();
          var tmp_17 = broad.condition_1;
          tmp = to(tmp_16, tmp_17 instanceof Condition() ? tmp_17 : THROW_CCE());
        } else {
          var tmp_18;
          if (narrow instanceof ListAnyElements()) {
            tmp_18 = broad instanceof ListAnyElements();
          } else {
            tmp_18 = false;
          }
          if (tmp_18) {
            var tmp_19 = narrow.condition_1;
            var tmp_20 = tmp_19 instanceof Condition() ? tmp_19 : THROW_CCE();
            var tmp_21 = broad.condition_1;
            tmp = to(tmp_20, tmp_21 instanceof Condition() ? tmp_21 : THROW_CCE());
          } else {
            var tmp_22;
            if (narrow instanceof SetAllElements()) {
              tmp_22 = broad instanceof SetAllElements();
            } else {
              tmp_22 = false;
            }
            if (tmp_22) {
              var tmp_23 = narrow.condition_1;
              var tmp_24 = tmp_23 instanceof Condition() ? tmp_23 : THROW_CCE();
              var tmp_25 = broad.condition_1;
              tmp = to(tmp_24, tmp_25 instanceof Condition() ? tmp_25 : THROW_CCE());
            } else {
              var tmp_26;
              if (narrow instanceof SetAnyElements()) {
                tmp_26 = broad instanceof SetAnyElements();
              } else {
                tmp_26 = false;
              }
              if (tmp_26) {
                var tmp_27 = narrow.condition_1;
                var tmp_28 = tmp_27 instanceof Condition() ? tmp_27 : THROW_CCE();
                var tmp_29 = broad.condition_1;
                tmp = to(tmp_28, tmp_29 instanceof Condition() ? tmp_29 : THROW_CCE());
              } else {
                tmp = null;
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
var BoundClass;
function Bound() {
  if (BoundClass === VOID) {
    class $ {
      constructor(value, lower, inclusive) {
        this.value_1 = value;
        this.lower_1 = lower;
        this.inclusive_1 = inclusive;
      }
    }
    initMetadataForClass($, 'Bound');
    BoundClass = $;
  }
  return BoundClass;
}
function asBound(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof GreaterThan()) {
    tmp = new (Bound())(_this__u8e3s4.value_1, true, false);
  } else {
    if (_this__u8e3s4 instanceof GreaterThanOrEqual()) {
      tmp = new (Bound())(_this__u8e3s4.value_1, true, true);
    } else {
      if (_this__u8e3s4 instanceof LessThan()) {
        tmp = new (Bound())(_this__u8e3s4.value_1, false, false);
      } else {
        if (_this__u8e3s4 instanceof LessThanOrEqual()) {
          tmp = new (Bound())(_this__u8e3s4.value_1, false, true);
        } else {
          tmp = null;
        }
      }
    }
  }
  return tmp;
}
function compareBoundValues(a, b) {
  var tmp;
  if (!(!(a == null) ? isComparable(a) : false)) {
    tmp = true;
  } else {
    tmp = b == null;
  }
  if (tmp)
    return null;
  if (!getKClassFromExpression(a).equals(getKClassFromExpression(b)))
    return null;
  return compareTo(isComparable(a) ? a : THROW_CCE(), b);
}
//region block: exports
export {
  impliesCondition as impliesCondition3tegm38vvcvlm,
};
//endregion

//# sourceMappingURL=ConditionImplies.mjs.map
